var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          _c("plan-selection", {
            attrs: {
              "submit-text": "Submit",
              "subscription-change": true,
              "wait-duration": 120000
            },
            on: { "on-cancel": _vm.onCancel, "on-continue": _vm.onContinue }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }